import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import * as serviceWorker from './serviceWorker';

import MainApp from 'MainApp'

// Disable non-error console output in production builds.
// `console.error` is preserved so genuine errors still surface to monitoring.
if (process.env.NODE_ENV === 'production') {
    const noop = () => {};
    ['log', 'debug', 'info', 'warn', 'trace', 'table', 'group', 'groupCollapsed', 'groupEnd'].forEach((method) => {
        if (typeof window.console[method] === 'function') {
            window.console[method] = noop;
        }
    });
}

function windowResize() {
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);
}

windowResize();
window.addEventListener('resize', windowResize);

ReactDOM.render(<MainApp/>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
